import { Card } from '@ipfabric/ui-components/Card/Card';
import { createFormSnippetGroup } from '@ipfabric/ui-components/utils/formSnippets/FormSnippetGroup';
import { SearchableSection } from '../../../components/DiscoverySearch/SearchableSection';
import { manualSiteSeparation } from '../../../snippets/SiteSeparation/ManualSiteSeparation';
import { ruleList } from '../../../snippets/SiteSeparation/RuleList/RuleList';
import { siteSeparationNeighborship } from '../../../snippets/SiteSeparation/SiteSeparationNeighborship';
import type { DiscoverySettingsGroupDisplayControl } from '../DiscoverySettings';

export const siteSeparationGroup = createFormSnippetGroup({
  snippets: {
    manualSiteSeparation,
    siteSeparationNeighborship,
    ruleList,
  },
  render: ({ renderSnippet }) => (
    // site separation must be in a flex column to be rendered correctly
    <div className='flex-1 flex flex-col gap'>
      <div className='text-default text-level-4 font-semibold font-heading'>
        Site separation
      </div>
      <Card className='flex-1 flex flex-col'>
        <SearchableSection
          className='flex flex-col flex-1 overflow-hidden'
          id='site-separation'
          searchTerms={['separation']}
          wrapperClassName='flex-1 flex flex-col'
        >
          <div className='p flex flex-col gap'>
            <p className='text-[1rem]'>
              Sites are separated collections of devices. Rule precedence is
              defined by the order from top to bottom.
            </p>
            <SearchableSection id='site-separation-manual-site-separation'>
              {renderSnippet('manualSiteSeparation')}
            </SearchableSection>
            <SearchableSection id='site-separation-neighbors'>
              {renderSnippet('siteSeparationNeighborship')}
            </SearchableSection>
          </div>
          <div className='border-t border-default mt-2' />
          <SearchableSection
            id='site-separation-rules'
            searchTerms={['Rule list']}
            className='flex flex-col flex-1'
            wrapperClassName='flex flex-col flex-1'
          >
            {renderSnippet('ruleList')}
          </SearchableSection>
        </SearchableSection>
      </Card>
    </div>
  ),
  show: (control: DiscoverySettingsGroupDisplayControl) => {
    control.setTab('siteSeparation');
  },
});
